
import { directoryCategories } from '../../../mocks/directory';

interface MobileCategoryBarProps {
  activeCategory: string;
  onCategoryChange: (cat: string) => void;
}

export default function MobileCategoryBar({ activeCategory, onCategoryChange }: MobileCategoryBarProps) {
  return (
    <div className="lg:hidden sticky top-[72px] z-30 bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex gap-2 py-3 overflow-x-auto scrollbar-hide">
          {directoryCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat.id
                  ? 'bg-teal-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              <i className={cat.icon}></i>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
